import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=77d1905e&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=77d1905e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d1905e",
  null
  
)

export default component.exports